﻿export class CountryOfVATEstablishmentOverviewModel {
    Id: string;
    ClientId: string;
    LegalEntityId: string;
    LegalEntityName: string;
    CountryName: string;
}